import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { FilterableIssue, MatcherCreator } from '../types.tsx';

export const issueProjectMatcherCreator: MatcherCreator<ProjectId[], FilterableIssue> = (
	projectFilter,
) => {
	const projectSet = new Set(projectFilter);
	return ({ projectId }) => !!projectId && projectSet.has(projectId);
};
